// extracted by mini-css-extract-plugin
export default {"h1-desktop":"H1_h1-desktop__3KwSd"};